/* src/app/components/lead-details/summary/lead-detail-summary/lead-detail-summary.component.css */
.chart-container {
  width: 500px;
  height: 500px;
}
.chart-box {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.ppl-form-item {
  width: 100% !important;
}
.filter-title {
  font-size: 1.714rem;
  font-weight: 600;
  color: #01796F;
  margin-bottom: 1rem;
  text-align: bottom;
}
.view-welcome-letter,
.download-welcome-letter {
  width: 100px;
  color: white !important;
}
.view-welcome-letter:focus-visible,
.download-welcome-letter:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
.download-welcome-letter {
  background-color: #0070f4;
}
.view-welcome-letter {
  background-color: #0080a6;
  border: none;
}
.button-container {
  display: flex;
  justify-content: space-evenly;
}
.summary-heading {
  background-color: #bebdf575;
  padding: 4px;
  border-radius: 4px;
  font-size: 1.286rem;
  margin-bottom: 10px;
  margin-top: 0;
  font-weight: 500;
}
.completed-count {
  font-size: 1.5rem !important;
}
.expiring-info {
  font-size: 1.25rem;
}
.expired-info {
  font-size: 1.5rem;
  color: red;
}
.highlight {
  color: #0073e2;
  cursor: pointer;
}
li.nostyle {
  list-style-type: none;
}
.tile-container {
  text-align: left;
  font-size: 16px;
  overflow-y: auto;
}
.wide-card {
  grid-column: span 2;
  justify-content: flex-start;
  max-height: 200px;
}
.util-auth-tile,
.pa-summary-tile {
  grid-column: span 3;
  text-align: left;
}
.tile-table-wrapper {
  overflow-y: auto;
  max-height: 200px;
}
.tile-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.tile-table thead th {
  background: #0203034d;
  color: #000000d9;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 6px 10px;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: nowrap;
}
.tile-table tbody td {
  padding: 6px 10px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
}
.tile-table tbody tr:hover {
  background-color: #fafafa;
}
.truncate-cell {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.auth-mco {
  font-weight: 500;
  color: #333;
  line-height: 1.3;
}
.auth-svc {
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
  line-height: 1.3;
}
.none-message {
  font-style: italic;
  color: #6c757d;
  margin: 8px 0;
  font-size: 13px;
}
.high-util {
  color: #ff0000;
}
.medium-util {
  color: #f08030;
}
.warning-text {
  color: #F59E0B;
}
.low-util,
.util-value {
  color: #01796f;
}
.red {
  color: #ef0000;
  font-weight: 600;
}
.timeoff-section {
  padding: 4px 0;
}
.timeoff-section:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}
.section-title {
  font-weight: 600;
  font-size: 15px;
  color: #0a7a6b;
  letter-spacing: 0.5px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.label {
  font-weight: 500;
  color: #6c757d;
}
.value {
  font-weight: 500;
  color: #333;
  margin-right: 8px;
}
.reverse-dir {
  direction: rtl;
}
.auth-table-wrapper {
  overflow-y: auto;
  max-height: 200px;
  text-align: left;
}
.auth-grid {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  width: 100%;
}
.auth-grid-row {
  display: grid;
  grid-template-columns: 2.5fr 0.8fr 1.1fr 0.8fr 0.8fr;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-bottom: 1px solid #f0f0f0;
}
.auth-grid-header {
  background: #f0f0f0;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.4px;
  color: #000000d9;
  position: sticky;
  top: 0;
  z-index: 1;
}
.auth-grid-data:hover {
  background-color: #fafafa;
}
.auth-mco {
  font-weight: 500;
  color: #333;
  line-height: 1.3;
}
.auth-svc {
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
  line-height: 1.3;
}
.none-message {
  font-weight: 500;
  color: #6c757d;
  margin: 8px 0;
}
.pa-summary-grid-row {
  display: grid;
  grid-template-columns: 2fr 0.9fr 1.3fr 0.6fr 1.7fr;
  align-items: center;
  gap: 6px;
  padding: 6px 0px 6px 4px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}
.pa-summary-grid-row.auth-grid-header {
  font-size: 12px;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
}
.pa-summary-grid-row.auth-grid-header {
  align-items: center;
}
.pa-summary-grid-row.auth-grid-header span {
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}
.pa-summary-grid-row span:first-child {
  text-align: left;
}
.icon-cell {
  text-align: center;
}
.clickable-count {
  cursor: pointer;
}
.clickable-count:hover {
  text-decoration: underline;
}
.pended-denied-grid-row {
  display: grid;
  grid-template-columns: 1.5fr 1.2fr 0.7fr 2fr;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  border-bottom: 1px solid #f0f0f0;
}
.pended-denied-grid-row.auth-grid-header span {
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}
.letters-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.letter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px;
  border-bottom: 1px solid #f0f0f0;
}
.letter-row:last-child {
  border-bottom: none;
}
.letter-name {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}
.letter-status-container {
  width: 208px;
}
.letter-status {
  font-size: 14px;
  font-weight: 600;
  color: #01796F;
  text-align: left;
}
.letter-row .button-container {
  gap: 8px;
}
.retirement-docs-alert {
  background-color: #fff59d;
  border-radius: 4px;
  padding: 4px 8px;
  margin-bottom: 8px;
}
/*# sourceMappingURL=lead-detail-summary.component-LAOU7PFZ.css.map */
